/**
 * Between 1 hour and 200 days
 * @param interval
 * @return {boolean}
 */
export const isValidInterval = (interval) => interval >= 60 && interval <= 288000;

export default isValidInterval;
